import { LayerDefinition } from './types';

export const wxStationsDefinition: LayerDefinition = {
  id: 'wx_stations',
  name: 'Weather Stations (Live METAR)',
  category: 'live_weather',
  categoryLabel: 'Surface Weather Observations',
  icon: '📡',
  description: 'Real-time surface weather observations (5-minute cadence) from ~7,300+ global NOAA Aviation Weather Center (METAR / ASOS / AWOS) and backcountry US Interagency RAWS mountain/wilderness weather stations with interactive Today, 7-Day, and 14-Day telemetry charts.',
  sourceModels: [
    'NOAA Aviation Weather Center (AWC) METAR / ASOS / AWOS Feed',
    'NIFC Interagency Remote Automatic Weather Stations (PublicView_RAWS)',
    'NOAA HADS / NWS & Iowa Environmental Mesonet Historical Archives'
  ],
  outputModels: [
    'Progressive-zoom WebGL station markers & readout badges',
    'Interactive 24H / 7-Day / 14-Day surface observation trend charts'
  ]
};

export default wxStationsDefinition;
